"use strict";

import configs from "@/config";
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
    data() {
        return {
            "gmap": {
                "circle": "",
                "interval": "",
                "link": "",
                "map": "",
            },
            "google": "",
            "googleApiKey": configs.googleApiKey,
        };
    },
    async mounted() {
        this.google = await GoogleMapsApiLoader({
            "apiKey": this.googleApiKey,
            "libraries": ["places", "geometry"],
        });
    },
    "methods": {
        // GoogleMapにマーカーを配置
        $_addMapMarker(data) {
            const marker = new this.google.maps.Marker({
                "draggable": data.draggable ? data.draggable : false,
                "map": this.gmap.map,
                "position": data.position,
            });
            // リンク指定がある場合はマーカーをクリックして別ウィンドウで表示
            if (data.link) {
                this.google.maps.event.addListener(marker, "click", () => {
                    window.open(data.link, "gmap");
                });
            }
        },
        // GoogleMapに円を描画
        $_addMapCircle(data) {
            return new this.google.maps.Circle({
                "map": this.gmap.map,
                "center": data.center,
                "radius": data.radius,
                "strokeColor": "#08f",
                "strokeOpacity": 0.8,
                "strokeWeight": 1,
                "fillColor": "#08f",
                "fillOpacity": 0.2,
            });
        },
        // 範囲判定後の処理
        $_gmapRangeAction(result) {
            if (result) {
                console.log("範囲内です！");
            } else {
                console.log("範囲外です。");
            }
        },
        // 範囲を判定
        $_getCircleRange(data) {
            // 現在位置とマーカーの距離を取得
            const distance = this.google.maps.geometry.spherical.computeDistanceBetween(data.position, data.location);
            // 距離より範囲が大きければ範囲内
            if (distance < data.range) {
                this.$_gmapRangeAction(true);
                // 定期更新を止める
                clearInterval(this.gmap.interval);
            } else {
                this.$_gmapRangeAction(false);
            }
        },
        // 現在位置を取得
        $_getCurrentPosition(data) {
            // 現在位置を取得できる場合の処理
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(pos => {
                    // 取得成功
                    // GoogleMap用の緯度経度を取得
                    const latlng = new this.google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                    // 円を描画
                    // 円が描画されている場合は位置を更新
                    if (this.gmap.circle) {
                        this.gmap.circle.setCenter(latlng);
                    } else {
                        this.gmap.circle = this.$_addMapCircle({
                            "center": latlng,
                            "radius": data.range ? data.range : 300,
                        });
                    }
                    // 円の中心までGoogleMapを移動
                    // this.gmap.map.panTo(latlng);
                    // 範囲を判定する場合の処理
                    // if (data.range) {
                    //     data.position = latlng;
                    //     this.$_getCircleRange(data);
                    // }
                }, () => {
                    return false;
                });
            }
        },
        // GoogleMapを表示
        $_gmap(data) {
            // Geocoderで住所から緯度経度を取得
            // GoogleCloudでAPIを別途有効にする必要あり
            const geocoder = new this.google.maps.Geocoder();
            geocoder.geocode({
                "address": data.address,
            }, (results, status) => {
                // 取得成功
                if (status === "OK" && results[0]) {
                    // 取得した緯度経度を保存
                    const location = results[0].geometry.location;
                    // 引数から緯度経度を取得した場合はそちらを優先とする
                    const lat = data.lat ? data.lat : location.lat();
                    const lng = data.lng ? data.lng : location.lng();
                    const latlng = new this.google.maps.LatLng(lat, lng);
                    // GoogleMapサイトへのリンクを保存
                    const link = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
                    // GoogleMapの描画
                    this.gmap.map = new this.google.maps.Map(this.$refs.googleMap, {
                        "center": latlng,
                        "fullscreenControl": false,
                        "mapTypeControl": false,
                        "streetViewControl": false,
                        "zoom": data.zoom ? data.zoom : 14,
                    });
                    // GoogleMapの中央に移動
                    this.gmap.map.panTo(latlng);
                    // GoogleMapの中央にマーカーを配置
                    this.$_addMapMarker({
                        "link": link,
                        "position": latlng,
                    });
                    // GoogleMapに現在位置を表示する場合の処理
                    if (data.current) {
                        const option = {
                            "location": latlng,
                            "range": data.range,
                        };
                        // 初回の表示
                        this.$_getCurrentPosition(option);
                        // 3秒毎に現在位置を更新
                        this.gmap.interval = setInterval(() => {
                            this.$_getCurrentPosition(option);
                        }, 3000);
                    }
                }
            }); 
        },
    },
};
